import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import { rProje } from '../../models/rProje';
import rList from '../../models/rList';

export default class ProjeListeleApi extends ApiBase<pList, rList<rProje>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/ProjeListele',
      }),
      options
    );
  }
}
